import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=7d5efe82"
import script from "@/scripts/settings/emailSettings.js?vue&type=script&lang=js&external"
export * from "@/scripts/settings/emailSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports